import styled from 'styled-components'

const badgeColors = {
  pending: {
    background: '#FFFAF0',
    color: 'rgba(221, 107, 32, 0.90)',
  },
  linked: {
    background: '#F0FFF4',
    color: '#38A169',
  },
  divergence: {
    background: '#FFF5F5',
    color: 'rgba(229, 62, 62, 0.90)',
  },
}

export const Badge = styled.div(
  ({ type = 'success' }) => `
    display: flex;
    height: 32px;
    padding: 4px 8px;
    align-items: center;
    gap: 8px;
    border-radius: 6px;
    background: ${badgeColors[type].background};

    & svg {
      width: 20px;
      height: 20px;
      color: ${badgeColors[type].color};
    }

    & span {
      color: ${badgeColors[type].color};
      leading-trim: both;
      text-edge: cap;
      font-feature-settings: 'liga' off, 'clig' off;
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 153.846% */
    }
  `
)

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: #fff;

  .paragraph {
    align-self: stretch;
    color: #74788d;
    leading-trim: both;

    text-edge: cap;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .title {
    color: #161616;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .simple-badge {
    display: flex;
    padding: 5px 10px;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    background: #2f2b3d0f;

    span {
      color: #2f2b3db2;
      font-feature-settings: 'liga' off, 'clig' off;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
    }
  }

  .cnpj-badge {
    display: flex;
    padding: 6px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid rgba(47, 43, 61, 0.08);
    background: rgba(248, 247, 250, 0.08);

    span {
      color: text-primary;
      leading-trim: both;
      text-edge: cap;
      font-feature-settings: 'liga' off, 'clig' off;
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
    }
  }
`

export const CardHeader = styled.div`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-bottom: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
`

export const CardFooter = styled.div`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;
  align-self: stretch;
  border-top: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
`

export const CardBody = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  position: relative;

  .icon--wrapper {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-container {
      display: flex;
      height: 32px;
      padding: 4px 8px;
      align-items: center;
      gap: 8px;
      border-radius: 6px;
      background: #7367f0;
      color: #fff;
    }
  }

  .left {
    display: flex;
    padding: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    flex: 1 1 50%;
    align-self: stretch;
    border-right: 1px solid rgba(0, 0, 0, 0.15);

    div:nth-child(2) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      align-self: stretch;

      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 16px;
      }
    }
  }

  .right {
    display: flex;
    padding: 24px 24px 24px 40px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 1 50%;
    width: 0;
    align-self: stretch;
  }
`

export const Button = styled.button(
  ({ type = 'sync' }) => `
  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
  border: none;
  transition: background-color 0.2s;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  &:disabled {
    opacity: 0.65;
    pointer-events: none;
  }

  ${
    type === 'sync' &&
    `
    background-color: #61c478;
    color: #FFFFFF;

    &:hover {
      background-color: #4fa96c;
    }

  `
  }

  ${
    type === 'unlink' &&
    `
    background-color: #ED5F5F;
    color: #ED5F5F;
    background-color: transparent;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  `
  }
`
)
